/**
 * @desc 获取根节点
 */
import { KindDetail } from '@eastcoal/api/system/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryKindRootNodesParameter = never

const method = 'GET'
const url = '/system/kind/root'

export const queryKindRootNodesApi = (
  params?: QueryKindRootNodesParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<KindDetail>>({
    method,
    url,
    params,
    ...config
  })
}

queryKindRootNodesApi.method = method
queryKindRootNodesApi.url = url
